import React from 'react'
import {KTSVG} from '../../../../helpers'
import {SEARCH_SUBMIT_ICON} from './searchTypeMeta'

interface SubmitButtonProps {
  onClick: () => void
  isFetching?: boolean
  disabled?: boolean
}

/** 52px magnifier submit button (GS-01). Shows a Metronic spinner while a query is in flight. */
export const SubmitButton: React.FC<SubmitButtonProps> = ({onClick, isFetching, disabled}) => (
  <button
    type='button'
    className='nb-gs__submit'
    onClick={() => !disabled && onClick()}
    disabled={disabled}
    aria-label='Search'
    style={disabled ? {cursor: 'not-allowed', opacity: 0.6} : undefined}
  >
    {isFetching ? (
      <span className='spinner spinner-border spinner-border-sm' role='status' aria-hidden='true' />
    ) : (
      <KTSVG path={SEARCH_SUBMIT_ICON} className='svg-icon-2' />
    )}
  </button>
)
